const config = {
  apiUrl: "https://tourmanager.kreller.de",
  debug: false,
};
export default config;